<div
  *ngIf="parentFormGroup &&
          parentFormGroup.controls &&
          parentFormGroup.controls[this.controlName]"
  [formGroup]="parentFormGroup"
  class="flex flex-row justify-start items-center"
>
  <mat-checkbox
    [disabled]="isDisabled"
    [formControlName]="controlName"
    aria-label="Select an option"
    class="checkbox {{error ? 'error':''}} {{this.type}}"
  >
    {{ label }}
  </mat-checkbox>
</div>
<div
  *ngIf="error"
  class="form-field-error justify-start"
>
  {{ error }}
</div>
